










import { Prop, Component, Vue } from "vue-property-decorator";
import _ from "lodash";
import { isWeekend } from "date-fns";

@Component
export default class VChartMask extends Vue {
  @Prop({ default: 1 }) cols!: number;
  @Prop({ default: () => [] }) days!: Date[];

  get length(): number {
    return this.days.length || this.cols;
  }

  get cells() {
    if (this.days.length) {
      return this.days.map(d => ({ className: isWeekend(d) ? "weekend" : "" }));
    } else {
      return _.range(0, this.cols).map(() => ({ className: "" }));
    }
  }
}
